export default class ImageAssignment {
  constructor(sourceContainer, destinationContainer, destinationDropAreaSelector, draggableElementSelector, explanationContainer) {
    this.sourceContainer = sourceContainer
    this.destinationContainer = destinationContainer
    this.destinationDropAreaSelector = destinationDropAreaSelector
    this.draggableElementSelector = draggableElementSelector
    this.explanationContainer = explanationContainer
    this.destinationContainerCopy = up.element.createFromHTML(destinationContainer.outerHTML)
    this.solution = null
  }

  get isCompleted() {
    let completed = true
    const destinationDropAreas = this.destinationContainer.querySelectorAll(this.destinationDropAreaSelector)

    for (const dropArea of destinationDropAreas) {
      const correct = this.isCorrect(dropArea)

      dropArea.classList.toggle('-correct', correct)
      dropArea.classList.toggle('-incorrect', !correct)

      completed &&= correct
    }

    return completed
  }

  isCorrect(dropArea) {
    const { reference, oneOfMultiple } = dropArea.dataset
    const containedDraggable = dropArea.querySelector(this.draggableElementSelector)

    if (containedDraggable) {
      const expectedReferences = JSON.parse(containedDraggable.dataset.targetAreaReferences || '[]')
      return expectedReferences.includes(reference)
    }

    if (this.findNuggetByReference(this.sourceContainer, reference)) {
      // an unplaced draggable exists that could have been placed here in the drop area.
      return false
    }

    if (!oneOfMultiple && this.findNuggetByReference(this.destinationContainer, reference)) {
      // expected draggable was placed elsewhere
      return false
    }

    // no draggable could be placed in this drop area. it's expected to be left empty.
    return true
  }

  buildSolution(solutionContainer) {
    if (!this.solution) {
      const solutionDropAreas = this.destinationContainerCopy.querySelectorAll(this.destinationDropAreaSelector)
      for (const dropArea of solutionDropAreas) {
        const { reference } = dropArea.dataset
        const nugget = this.findNuggetByReference(this.sourceContainer, reference) || this.findNuggetByReference(this.destinationContainer, reference)

        if (nugget) {
          // Cloning source nuggets for games where a single nugget is valid for multiple drop areas ("data-one-of-multiple")
          dropArea.appendChild(nugget.cloneNode({ deep: true }))
        }
      }
      this.solution = this.destinationContainerCopy
    }
    solutionContainer.appendChild(this.solution)

    const explanationClone = up.element.createFromHTML(this.explanationContainer.outerHTML)
    explanationClone.removeAttribute('hidden')
    solutionContainer.appendChild(explanationClone)

    solutionContainer.querySelectorAll('.highlight').forEach((element) => {
      // might be present due to read-aloud
      element.classList.remove('highlight')
    })
  }

  findNuggetByReference(container, reference) {
    const selector = `${this.draggableElementSelector}[data-target-area-references*=${reference}]`
    return container.querySelector(selector)
  }
}
